module.exports = __webpack_public_path__ + "static/media/calendar-ic.7596529a.svg";